import { render } from "./StoreDocumentTab.vue?vue&type=template&id=2aac96c8&scoped=true"
import script from "./StoreDocumentTab.vue?vue&type=script&lang=js"
export * from "./StoreDocumentTab.vue?vue&type=script&lang=js"

import "./StoreDocumentTab.vue?vue&type=style&index=0&id=2aac96c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aac96c8"]])

export default __exports__